// extracted by mini-css-extract-plugin
export default {"root":"SubscriptionUpgradeModal_root__MoHb1","container":"SubscriptionUpgradeModal_container__cpS7V","body":"SubscriptionUpgradeModal_body__0zGJS"};